import { render } from "./TalentReportForm.vue?vue&type=template&id=6367cfea&scoped=true"
import script from "./TalentReportForm.vue?vue&type=script&lang=js"
export * from "./TalentReportForm.vue?vue&type=script&lang=js"

import "./TalentReportForm.vue?vue&type=style&index=0&id=6367cfea&lang=css"
import "./TalentReportForm.vue?vue&type=style&index=1&id=6367cfea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6367cfea"]])

export default __exports__